import currencyFormatter from 'currency-formatter'

export const currencyFormat = price => {
	return currencyFormatter.format(price, {
		code: 'MXN',
		symbol: '$'
	})
}
